import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.168 7.975H0V6.031h10.175L5.382 1.374 6.796 0 14 7l-7.204 7-1.414-1.374 4.786-4.65z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
